"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEventStartDateProperty = exports.eventStartDatePropertyDefinition = void 0;
exports.eventStartDatePropertyDefinition = {
    name: 'event-start-date',
    type: 'date-time',
    constraints: [
        {
            name: 'required',
            argument: true,
        },
    ],
    multiple: false,
    view: { label: 'Event start date' },
};
const isEventStartDateProperty = (prop) => {
    return prop.name === exports.eventStartDatePropertyDefinition.name;
};
exports.isEventStartDateProperty = isEventStartDateProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZXZlbnQtc3RhcnQtZGF0ZS5wcm9wZXJ0eS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9wcm9wZXJ0aWVzL2V2ZW50LXN0YXJ0LWRhdGUucHJvcGVydHkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRWEsUUFBQSxnQ0FBZ0MsR0FBRztJQUM5QyxJQUFJLEVBQUUsa0JBQWtCO0lBQ3hCLElBQUksRUFBRSxXQUFXO0lBQ2pCLFdBQVcsRUFBRTtRQUNYO1lBQ0UsSUFBSSxFQUFFLFVBQVU7WUFDaEIsUUFBUSxFQUFFLElBQUk7U0FDZjtLQUNGO0lBQ0QsUUFBUSxFQUFFLEtBQUs7SUFDZixJQUFJLEVBQUUsRUFBRSxLQUFLLEVBQUUsa0JBQWtCLEVBQUU7Q0FDSixDQUFBO0FBSTFCLE1BQU0sd0JBQXdCLEdBQUcsQ0FBQyxJQUFrQixFQUFrQyxFQUFFO0lBQzdGLE9BQU8sSUFBSSxDQUFDLElBQUksS0FBSyx3Q0FBZ0MsQ0FBQyxJQUFJLENBQUE7QUFDNUQsQ0FBQyxDQUFBO0FBRlksUUFBQSx3QkFBd0IsNEJBRXBDIn0=